/** InsCoder 2026-09-24 B + Keep Affirm messaging scoped and current on variant changes **/
(function () {
  var INIT_FLAG = 'custAffirmAmountInitialized';

  function init() {
    var pubsub = window.theme && window.theme.pubsub;
    if (!pubsub || window[INIT_FLAG]) return;
    window[INIT_FLAG] = true;

    pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, function (payload) {
      var data = payload && payload.data;
      var variant = data && data.variant;
      if (!variant || !data.sectionId || !data.productId) return;

      var productInfo = document.getElementById('ProductInfo-' + data.sectionId + '-' + data.productId);
      var item = productInfo && productInfo.querySelector('.affirm-message-container .affirm-message-item');
      if (!item) return;

      item.dataset.variantId = String(variant.id);
      item.dataset.amount = String(variant.price);
      item.classList.add('selected');

      var affirm = window.affirm;
      if (affirm && affirm.ui && typeof affirm.ui.ready === 'function') {
        affirm.ui.ready(function () {
          if (typeof affirm.ui.refresh === 'function') affirm.ui.refresh();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/** InsCoder 2026-09-24 E + Keep Affirm messaging scoped and current on variant changes **/
